module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Cudrefin_(Vaud)-568e79e57f87f5233e983843b3adb3e4.svg";